export default __webpack_public_path__ + "static/media/excavation1.5adadbfa.png";